import * as React from 'react';
import styled from 'styled-components';
import { header3 } from '@westwing/ui-kit/typography';
import { forDesktop } from '@westwing/ui-kit/breakPoints';
import HybridLink from './Generic/Links/HybridLink';
import UnsupportedImageLink from 'Client/assets/images/unsupported-page-image.jpg';
import UnsupportedDesktopImageLink from 'Client/assets/images/unsupported-page-image-desktop.jpg';
import useBellaTranslator from 'Client/hooks/useTranslator';
import { SEOHead } from 'Common/Microfrontend';

const PageContainer = styled.div`
    background: url(${UnsupportedImageLink}) no-repeat center / cover;
    height: 86vh;
    padding: 1.25em;
    ${forDesktop`
        background: url(${UnsupportedDesktopImageLink}) no-repeat center / contain;
        height: 713px;
    `}
`;

const MessageContainer = styled.div`
    width: 100%;
    max-width: 440px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 10%;
    text-align: center;
`;

const MessageHeader = styled.div`
    ${header3}
    color: ${({ theme }) => theme.colors.charcoal100};
    font-style: italic;
`;

const Message = styled.div`
    color: ${({ theme }) => theme.colors.charcoal100};
    padding: 5% 0 10% 0;
    ${forDesktop`
        padding: 25px 0;
    `}
`;

const HomeLinkButton = styled(HybridLink)`
    display: block;
    margin: auto;
    width: 100%;
    max-width: 340px;
    padding: 1em;
    text-align: center;
    background: ${({ theme }) => theme.colors.charcoal100};
    border: none;
    color: ${({ theme }) => theme.colors.white};
    text-decoration: none;
`;

const useUnsupportedBrowser = () => {
    const [isUnsupportedBrowser, setIsUnsupportedBrowser] = React.useState(false);

    React.useEffect(() => {
        if (/Trident\/|MSIE/.test(window.navigator.userAgent)) {
            setIsUnsupportedBrowser(true);
        }
    }, []);

    return isUnsupportedBrowser;
};

const UnsupportedBrowser = () => {
    const t = useBellaTranslator();

    return (
        <PageContainer>
            <MessageContainer>
                <MessageHeader>{t('ie11_not-supported_title')}</MessageHeader>
                <Message>{t('ie11_not-supported_paragraph')}</Message>
                <HomeLinkButton to="/">{t('ie11_not-supported_CTA')}</HomeLinkButton>
            </MessageContainer>
        </PageContainer>
    );
};

const UnsupportedBrowserPage = () => (
    <>
        <SEOHead noIndex />
        <UnsupportedBrowser />
    </>
);

export { UnsupportedBrowserPage as default, UnsupportedBrowser, useUnsupportedBrowser };
